(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fathers-day-landing"] && !Shopify.designMode) return;
  try {
    
(function() {
  var el = document.querySelector('.fdd');
  if (!el) return;

  try {
    if (window.posthog) {
      posthog.capture('fathers_day_lp_viewed', {
        page_handle: el.dataset.pageHandle,
        template_suffix: el.dataset.templateSuffix
      });
    }
  } catch(e) {}

  el.querySelectorAll('.fdd__track').forEach(function(btn) {
    btn.addEventListener('click', function() {
      try {
        if (window.posthog) {
          posthog.capture('fathers_day_cta_clicked', {
            cta_label: btn.dataset.phLabel,
            cta_position: btn.dataset.phPos,
            cta_href: btn.getAttribute('href')
          });
        }
      } catch(e) {}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-earth-entry-router"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.getElementById('home-earth-entry-router-json');
    if (!el) return;
    var cfg;
    try {
      cfg = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }

    function getCookie(name) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    }

    function setCookie(name, value, days) {
      var maxAge = Math.floor(days * 86400);
      document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;max-age=' + maxAge + ';SameSite=Lax';
    }

    function buildUrl(path, lpVar) {
      var base =
        path.indexOf('http') === 0
          ? path
          : window.location.origin + (path.charAt(0) === '/' ? path : '/' + path);
      var u;
      try {
        u = new URL(base);
      } catch (e) {
        return base;
      }
      u.searchParams.set('lp_var', lpVar);
      if (cfg.appendCurrency) u.searchParams.set('currency', 'USD');
      return u.toString();
    }

    var homePath = cfg.homePath || '/';
    var earthPath = cfg.earthPath || '/pages/earth-month-misprints';
    if (earthPath === '/pages/earth-month-misprints-draft') earthPath = '/pages/earth-month-misprints';
    var flagKey = cfg.posthogFlagKey || 'mpc_home_vs_earth_lander_v1';
    var redirected = false;

    function go(path, lpVar, flagValue, options) {
      if (redirected) return;
      redirected = true;
      var skipCookie = options && options.skipCookie;
      if (!skipCookie) {
        setCookie(cfg.cookieName, lpVar, Number(cfg.cookieDays) || 30);
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'entry_split_assign',
        lp_test_name: cfg.testName,
        lp_variant: lpVar,
        entry_experiment: flagKey,
        posthog_flag_value: flagValue
      });
      try {
        if (typeof posthog !== 'undefined' && posthog.capture) {
          posthog.capture('entry_split_assigned', {
            experiment: flagKey,
            posthog_flag_value: flagValue,
            lp_variant: lpVar,
            lp_test_name: cfg.testName,
            destination_path: path
          });
        }
        if (typeof posthog !== 'undefined' && posthog.register_for_session) {
          posthog.register_for_session({
            home_earth_lp_variant: lpVar,
            home_earth_experiment: flagKey
          });
        }
      } catch (e) {}
      var dest = buildUrl(path, lpVar);
      window.setTimeout(function () {
        window.location.replace(dest);
      }, 120);
    }

    function fromCookie() {
      var stored = getCookie(cfg.cookieName);
      if (stored === 'earth') return { path: earthPath, lpVar: 'earth', fv: 'cookie' };
      if (stored === 'home') return { path: homePath, lpVar: 'home', fv: 'cookie' };
      return null;
    }

    var qs = new URLSearchParams(window.location.search);
    var preview = (qs.get('mpc_router_preview') || '').toLowerCase();
    if (preview === 'earth' || preview === 'home') {
      go(
        preview === 'earth' ? earthPath : homePath,
        preview === 'earth' ? 'earth' : 'home',
        'preview_' + preview,
        { skipCookie: true }
      );
      return;
    }

    var cached = fromCookie();
    if (cached) {
      go(cached.path, cached.lpVar, cached.fv);
      return;
    }

    if (typeof posthog !== 'undefined' && posthog.onFeatureFlags) {
      var t = window.setTimeout(function () {
        if (!redirected) go(homePath, 'home', 'timeout_fallback');
      }, 4000);
      posthog.onFeatureFlags(function () {
        window.clearTimeout(t);
        if (redirected) return;
        var fv = posthog.getFeatureFlag(flagKey);
        if (fv === 'test') go(earthPath, 'earth', 'test');
        else go(homePath, 'home', fv === 'control' ? 'control' : String(fv));
      });
    } else {
      go(homePath, 'home', 'no_posthog');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystery-landing-router"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.getElementById('mystery-router-json');
    if (!el) return;
    var cfg;
    try {
      cfg = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    var variants = cfg.variants || [];
    if (!variants.length) return;

    function getCookie(name) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    }

    function setCookie(name, value, days) {
      var maxAge = Math.floor(days * 86400);
      document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;max-age=' + maxAge + ';SameSite=Lax';
    }

    function findVariantByKey(key) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].key === key) return variants[i];
      }
      return null;
    }

    function variantsForAbFallback() {
      var ck = cfg.abControlVariantKey || 'classic';
      var tk = cfg.abTestVariantKey || 'brand';
      var out = [];
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].key === ck || variants[i].key === tk) out.push(variants[i]);
      }
      return out.length ? out : variants;
    }

    function pickVariant() {
      var pool = cfg.posthogExperimentEnabled ? variantsForAbFallback() : variants;
      var stored = getCookie(cfg.cookieName);
      if (stored) {
        for (var i = 0; i < pool.length; i++) {
          if (pool[i].key === stored) return pool[i];
        }
      }
      var idx = Math.floor(Math.random() * pool.length);
      return pool[idx];
    }

    function buildUrl(path, key) {
      var base = path.indexOf('http') === 0 ? path : window.location.origin + (path.charAt(0) === '/' ? path : '/' + path);
      var u;
      try {
        u = new URL(base);
      } catch (e) {
        return base;
      }
      u.searchParams.set('lp_var', key);
      if (cfg.appendCurrency) u.searchParams.set('currency', 'USD');
      return u.toString();
    }

    var redirected = false;

    function go(chosen) {
      if (redirected || !chosen) return;
      redirected = true;
      setCookie(cfg.cookieName, chosen.key, Number(cfg.cookieDays) || 30);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mystery_lp_assign',
        lp_test_name: cfg.testName,
        lp_variant: chosen.key
      });
      var dest = buildUrl(chosen.path, chosen.key);
      window.setTimeout(function () {
        window.location.replace(dest);
      }, 120);
    }

    if (cfg.posthogExperimentEnabled && typeof posthog !== 'undefined' && posthog.onFeatureFlags) {
      var flagKey = cfg.posthogFlagKey || 'mpc_mystery_lp_ab_v1';
      var controlK = cfg.abControlVariantKey || 'classic';
      var testK = cfg.abTestVariantKey || 'brand';
      var fallbackTimer = window.setTimeout(function () {
        if (!redirected) go(pickVariant());
      }, 4000);
      posthog.onFeatureFlags(function () {
        window.clearTimeout(fallbackTimer);
        if (redirected) return;
        var fv = posthog.getFeatureFlag(flagKey);
        var lpKey = fv === 'test' ? testK : controlK;
        var chosen = findVariantByKey(lpKey) || pickVariant();
        go(chosen);
      });
    } else {
      go(pickVariant());
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystery-mousepad-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (typeof posthog === 'undefined') return;
  var section = document.querySelector('.mystery');
  if (!section) return;

  var variant = section.classList.contains('mystery--earth') ? 'earth'
    : section.classList.contains('mystery--brand') ? 'brand' : 'classic';
  var base = { lp_variant: variant, page_url: location.pathname };

  function label(el) {
    if (el.closest('.mystery__earth-pack-btn--best, .mystery__pack--best')) return '3_pack_best';
    if (el.closest('.mystery__earth-pack-btn, .mystery__pack')) {
      var txt = el.textContent || '';
      if (/1.pack/i.test(txt)) return '1_pack';
      if (/2.pack/i.test(txt)) return '2_pack';
      if (/3.pack/i.test(txt)) return '3_pack';
    }
    if (el.closest('.mystery__close-action')) return 'closing_cta';
    if (el.closest('.mystery__ctas')) {
      return el.classList.contains('button--outline') ? 'hero_secondary_cta' : 'hero_primary_cta';
    }
    return el.textContent.trim().slice(0, 40).toLowerCase().replace(/\s+/g, '_');
  }

  section.addEventListener('click', function (e) {
    var link = e.target.closest('a, button, .button');
    if (!link) return;
    posthog.capture('lp_click', Object.assign({}, base, {
      element: label(link),
      href: link.href || null,
      section_name: (function () {
        if (link.closest('.mystery__hero')) return 'hero';
        if (link.closest('.mystery__earth-packs')) return 'pick_your_pack';
        if (link.closest('.mystery__packs')) return 'pick_your_pack';
        if (link.closest('.mystery__close')) return 'closing_cta';
        if (link.closest('.mystery__faq')) return 'faq';
        return 'other';
      })()
    }));
  });

  var faqItems = section.querySelectorAll('.mystery__faq-item');
  faqItems.forEach(function (det) {
    det.addEventListener('toggle', function () {
      if (!det.open) return;
      var q = det.querySelector('summary');
      posthog.capture('lp_faq_opened', Object.assign({}, base, {
        question: q ? q.textContent.trim() : 'unknown'
      }));
    });
  });

  var thresholds = [25, 50, 75, 100];
  var fired = {};
  var ticking = false;
  function checkScroll() {
    var docH = document.documentElement.scrollHeight - window.innerHeight;
    if (docH <= 0) return;
    var pct = Math.round((window.scrollY / docH) * 100);
    thresholds.forEach(function (t) {
      if (pct >= t && !fired[t]) {
        fired[t] = true;
        posthog.capture('lp_scroll_depth', Object.assign({}, base, { depth_pct: t }));
      }
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(checkScroll); }
  }, { passive: true });

  var visibleSections = {};
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var name = entry.target.dataset.phSection;
        if (name && !visibleSections[name]) {
          visibleSections[name] = true;
          posthog.capture('lp_section_viewed', Object.assign({}, base, { section_name: name }));
        }
      });
    }, { threshold: 0.3 });

    var targets = [
      { sel: '.mystery__hero', name: 'hero' },
      { sel: '.mystery__earth-packs, .mystery__packs', name: 'pick_your_pack' },
      { sel: '.mystery__reviews', name: 'reviews' },
      { sel: '.mystery__faq', name: 'faq' },
      { sel: '.mystery__close', name: 'closing_cta' },
      { sel: '.mystery__gallery', name: 'gallery' },
      { sel: '.mystery__sizes', name: 'pick_your_size' }
    ];
    targets.forEach(function (t) {
      var el = section.querySelector(t.sel);
      if (el) { el.dataset.phSection = t.name; obs.observe(el); }
    });
  }

  var startTime = Date.now();
  function sendEngagement() {
    var seconds = Math.round((Date.now() - startTime) / 1000);
    if (seconds < 3) return;
    posthog.capture('lp_engagement_time', Object.assign({}, base, { seconds_on_page: seconds }));
  }
  window.addEventListener('beforeunload', sendEngagement);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') sendEngagement();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
